import { render, staticRenderFns } from "./supplement.vue?vue&type=template&id=dd778cc0&scoped=true&"
import script from "./supplement.vue?vue&type=script&lang=js&"
export * from "./supplement.vue?vue&type=script&lang=js&"
import style0 from "../../static/oa-img/css/index.css?vue&type=style&index=0&id=dd778cc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd778cc0",
  null
  
)

export default component.exports